import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { SiWhatsapp } from "@/components/site/Brands";
import { waLink } from "@/data/site";

export const WhatsAppFloat = () => (
  <a href={waLink("preventivo")} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn" aria-label="Scrivici su WhatsApp"
    className="fixed bottom-6 right-6 z-40 hidden h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-10px_rgba(37,211,102,0.8)] transition-transform hover:scale-105 lg:grid">
    <SiWhatsapp className="h-7 w-7" />
  </a>
);

export const MobileBar = () => (
  <div data-testid="mobile-cta-bar" className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-slate-200 bg-white/95 p-3 backdrop-blur-xl lg:hidden">
    <Link to="/preventivo-gratuito" data-testid="mobile-bar-quote-btn" className="btn-primary !py-3"><FileText className="h-4 w-4" />Preventivo</Link>
    <a href={waLink("preventivo")} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-whatsapp-btn" className="btn !py-3 bg-[#128C4A] text-white"><SiWhatsapp className="h-4 w-4" />WhatsApp</a>
  </div>
);
